module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.error) ? _c('div', [_c('h2', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.error))])]) : _vm._e(), _vm._v(" "), (_vm.loading == true) ? _c('div', {
    staticClass: "container"
  }, [_vm._m(0)]) : _vm._e(), _vm._v(" "), (_vm.reservationReadyComp && _vm.isActiveComp == true && !_vm.loading) ? _c('div', {
    staticClass: "container"
  }, [_c('h2', {
    staticClass: "small-h2 text-center",
    staticStyle: {
      "margin-bottom": "0px"
    }
  }, [_c('i', {
    staticClass: "fa fa-list-alt"
  }), _vm._v(" Booking ID: "), _c('strong', [_vm._v(_vm._s(_vm.existingReservationComp.BookingNumber) + " ")])]), _vm._v(" "), _c('hr', {
    staticStyle: {
      "margin-top": "5px"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "ratingRequest",
      "role": "dialog",
      "aria-labelledby": "modalLabel",
      "tabindex": "-1"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('h4', [_c('i', {
    staticClass: "fa fa-thumbs-o-up",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" How would you rate " + _vm._s(_vm.existingReservationComp.SitterName) + "?")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body ",
    staticStyle: {
      "overflow": "hidden"
    }
  }, [_c('div', {
    staticClass: "well"
  }, [_c('div', [_c('star-rating', {
    attrs: {
      "show-rating": false,
      "border-width": 3
    },
    on: {
      "rating-selected": _vm.setRating
    }
  }), _vm._v(" "), _c('hr'), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.reviewDesc),
      expression: "reviewDesc"
    }],
    staticClass: "form-control",
    attrs: {
      "rows": "3",
      "placeholder": "We would love to hear your feedback on this stay",
      "id": "comment"
    },
    domProps: {
      "value": (_vm.reviewDesc)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.reviewDesc = $event.target.value
      }
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "pull-right"
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button",
      "disabled": !_vm.customerRating
    },
    on: {
      "click": function($event) {
        _vm.submitRating()
      }
    }
  }, [_vm._v("Send Rating")])])])])])]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "hidden-lg hidden-md"
  }, [_c('button', {
    staticClass: "hidden-md hidden-lg btn btn-block btn-lg btn-info btn-title",
    attrs: {
      "data-toggle": "collapse",
      "data-target": "#summary"
    },
    on: {
      "click": function($event) {
        _vm.switchCollapse()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa fa-navicon"
  }), _vm._v("   " + _vm._s(_vm.summaryComp))]), _vm._v(" "), _c('div', {
    staticClass: " hidden-md hidden-lg collapse",
    staticStyle: {
      "margin-left": "0px",
      "padding-left": "0px",
      "margin-right": "0px",
      "padding-right": "0px"
    },
    attrs: {
      "id": "summary"
    }
  }, [_c('div', {
    staticClass: "reservationSummary"
  }, [_vm._l((_vm.existingReservationComp.AvailablePetDtos), function(petCard) {
    return _c('div', [_c('div', [_c('PetSelectCard', {
      key: petCard.PetId,
      attrs: {
        "showDetails": true,
        "petId": petCard.PetId
      }
    })], 1)])
  }), _vm._v(" "), _c('div', {
    staticClass: "summary-desc"
  }, [(!_vm.isDogWalking) ? _c('h5', [_vm._v("Total Days: " + _vm._s(_vm.existingReservationComp.TotalDays))]) : _vm._e(), _vm._v(" "), (!_vm.isDogWalking) ? _c('h5', [_vm._v("Dates: " + _vm._s(_vm.startDateComp) + " - " + _vm._s(_vm.endDateComp))]) : _vm._e(), _vm._v(" "), (_vm.isDogWalking) ? _c('h5', [_vm._v("Starting " + _vm._s(_vm.startDateComp))]) : _vm._e(), _vm._v(" "), _vm._l((_vm.existingReservationComp.ServicePriceSummaryDtos), function(service) {
    return _c('h5', [_vm._v(_vm._s(service.Description))])
  }), _vm._v(" "), _c('h4', {
    staticClass: "text-success"
  }, [_vm._v("Total Price: " + _vm._s(_vm.totalPriceComputed) + " " + _vm._s(_vm.currencyComp) + " "), (_vm.isDogWalking) ? _c('span', [_vm._v(" per week")]) : _vm._e()])], 2)], 2)]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-7 remove-margins"
  }, [(_vm.existingReservationComp.CustomerStatus) ? _c('div', {
    staticClass: "alert alert-dismissible",
    class: _vm.existingReservationComp.StatusClass,
    attrs: {
      "role": "alert"
    }
  }, [_vm._m(1), _vm._v(" "), _c('h5', [_c('strong', [_vm._v("Status: ")]), _vm._v(_vm._s(_vm.existingReservationComp.CustomerStatus))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "media-left"
  }, [_c('img', {
    staticClass: "media-object img-responsive img-circle",
    attrs: {
      "src": _vm.existingReservationComp.SitterProfilePic,
      "alt": "",
      "height": "25",
      "width": "25"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "media-left head-title"
  }, [_c('h4', {
    staticClass: "media-heading ",
    staticStyle: {
      "padding-bottom": "0px",
      "margin-bottom": "0px"
    }
  }, [_vm._v(" " + _vm._s(_vm.existingReservationComp.SitterName))])]), _vm._v(" "), (_vm.signalReadyComp) ? _c('Chat', {
    attrs: {
      "isSitterAccepted": _vm.existingReservationComp.IsSitterAccepted,
      "transactionId": _vm.reservationIdComp
    }
  }) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), (!_vm.rejectedComp) ? _c('div', {
    staticClass: "buttons"
  }, [(_vm.existingReservation.IsSitterAccepted == true) ? _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.existingReservation.IsConfirmedBooking),
      expression: "!existingReservation.IsConfirmedBooking"
    }],
    staticClass: "btn btn-title btn-block btn-success",
    staticStyle: {
      "margin-bottom": "5px"
    },
    attrs: {
      "data-toggle": "popover"
    },
    on: {
      "click": function($event) {
        _vm.confirmBooking()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-check-o"
  }), _vm._v("\n            Confirm Booking")]) : _vm._e(), _vm._v(" "), _c('div', [(_vm.existingReservationComp.StatusCode == 0) ? _c('div', {
    staticClass: "text-center",
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_c('a', {
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        _vm.whatToDoNext()
      }
    }
  }, [_vm._v("What should I do now?")])]) : _vm._e(), _vm._v(" "), (_vm.existingReservationComp.IsCustomerCancelled == false) ? _c('button', {
    staticClass: "btn btn-block  btn-warning",
    attrs: {
      "data-toggle": "popover"
    },
    on: {
      "click": function($event) {
        _vm.cancelRequest()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-trash-o"
  }), _vm._v(" Cancel Request")]) : _vm._e(), _vm._v(" "), _c('br')])]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn btn-block btn-info btn-lg",
    on: {
      "click": function($event) {
        _vm.goMyReservations()
      }
    }
  }, [_vm._v("View all Bookings")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-block btn-success btn-lg",
    on: {
      "click": function($event) {
        _vm.findSitters()
      }
    }
  }, [_vm._v("Find More Sitters "), _c('i', {
    staticClass: "fa fa-paw"
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "hidden-xs hidden-sm col-md-4 pull-right reservationSummary"
  }, [_c('h4', {
    staticClass: "text-center"
  }, [_vm._v(" Summary ")]), _vm._v(" "), _vm._l((_vm.existingReservationComp.AvailablePetDtos), function(petCard) {
    return _c('div', [_c('div', [_c('PetSelectCard', {
      key: petCard.PetId,
      attrs: {
        "showDetails": true,
        "petId": petCard.PetId
      }
    })], 1)])
  }), _vm._v(" "), (!_vm.isDogWalking) ? _c('h5', {
    staticClass: "small"
  }, [_vm._v("Total Days: " + _vm._s(_vm.existingReservationComp.TotalDays))]) : _vm._e(), _vm._v(" "), (!_vm.isDogWalking) ? _c('h5', {
    staticClass: "small"
  }, [_vm._v("Dates: " + _vm._s(_vm.startDateComp) + " - " + _vm._s(_vm.endDateComp))]) : _vm._e(), _vm._v(" "), (_vm.isDogWalking) ? _c('h5', [_vm._v("Starting " + _vm._s(_vm.startDateComp))]) : _vm._e(), _vm._v(" "), _vm._l((_vm.existingReservationComp.ServicePriceSummaryDtos), function(service) {
    return _c('h5', {
      staticClass: "small"
    }, [_vm._v(_vm._s(service.Description))])
  }), _vm._v(" "), _c('h4', {
    staticClass: "text-success"
  }, [_vm._v("Total Price: " + _vm._s(_vm.totalPriceComputed) + " " + _vm._s(_vm.currencyComp) + " "), (_vm.isDogWalking) ? _c('span', [_vm._v(" per week")]) : _vm._e()])], 2)])]) : _vm._e(), _vm._v(" "), (_vm.isActiveComp == false) ? _c('div', [_c('br'), _vm._v(" "), _c('h1', {
    staticClass: "text-center"
  }, [_vm._v("You need to have an active membership to view this reservation")]), _vm._v(" "), _c('p', {
    staticClass: "text-center"
  }, [_vm._v("Note: Only pet sitters who are Premium can respond to you without an active membership")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 col-md-offset-4"
  }, [_c('br'), _vm._v(" "), _c('button', {
    staticClass: "btn btn-block btn-success",
    on: {
      "click": function($event) {
        _vm.goSubscribe()
      }
    }
  }, [_vm._v("Subscribe Now")])])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text-center"
  }, [_c('div', {
    staticClass: "spinner"
  }, [_c('div', {
    staticClass: "bounce1"
  }), _vm._v(" "), _c('div', {
    staticClass: "bounce2"
  }), _vm._v(" "), _c('div', {
    staticClass: "bounce3"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "alert",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-4c2283f5!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Customers/Reservation/ViewReservationComponent.vue
// module id = 630
// module chunks = 2